import RestService from '@services/RestService';
import {
  downloadFileFromBinary,
  getFilenameFromHeader
} from '@utils/downloadFile';

const totalOrderService = {
  async getTotalOrders(data) {
    try {
      const res = await new RestService()
        .setPath('/client-admin/order/list')
        .post(data);

      return { data: res?.data, error: null };
    } catch (err) {
      return { error: err?.response?.data || err, data: null };
    }
  },
  async createMember(data) {
    try {
      const res = await new RestService()
        .setPath('/client-admin/order/receipt')
        .post(data);
      return { data: res?.data, error: null };
    } catch (err) {
      return { error: err?.response?.data || err, data: null };
    }
  },
  async exportTotalOrder(data) {
    try {
      const res = await new RestService()
        .setPath('/client-admin/order/export')
        .setResponseType('blob')
        .post(data);

      const filename = getFilenameFromHeader(res.headers);
      if (res?.data) downloadFileFromBinary(res.data, filename);

      return { data: res?.data, error: null };
    } catch (err) {
      return { error: err?.response?.data || err, data: null };
    }
  },
  async getPaymentHistory(id) {
    try {
      const res = await new RestService()
        .setPath(`client-admin/member/${id}/payment-history`)
        .get();
      return { data: res?.data, error: null };
    } catch (err) {
      return { error: err?.response?.data || err, data: null };
    }
  }
};

export default totalOrderService;
